import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toolIdToName'
})
export class ToolIdToNamePipe implements PipeTransform {

  transform(toolId: number): string {
    switch (toolId) {
      case -1: return "Invalid Tool";
      case 1: return "Ruler";
      case 2: return "Depth Guage";
      case 3: return "Ultrasonic Tool";
      case 4: return "Calipers";
      case 5: return "Keeper Pin Observation";
      case 6: return "Drive Lugs Engaged";
      case 7: return "Yes or No";
      case 8: return "Observation";
    }
  }

}
